import styled from "styled-components";
import { Link } from "react-router-dom";
import { ate, ALVO_DE_TOQUE, BOTAO_LEGIVEL } from "../global/breakpoints";

export const WelcomeContainer = styled.div`
  opacity: 1;
  z-index: 2;
  padding: var(--sp-20);
  max-width: calc(var(--u) * 1000);
  margin: 0 auto;
  /* max-width sozinho não impede estouro: o conteúdo interno (mapa, grade de
     métricas) precisa poder encolher, e para isso a caixa tem de contar o
     padding dentro da largura. */
  width: 100%;
  box-sizing: border-box;

  ${ate.tablet} {
    padding: var(--sp-12);
  }
`;

export const MainCard = styled.div`
  background-color: ${(props) => props.theme.colors.background + "cc"};
  color: ${(props) => props.theme.colors.text};
  border: 1px solid ${(props) => props.theme.colors.text};
  border-radius: 8px;
`;
export const WelcomeHeader = styled.div`
  display: flex;
  justify-content: center; /* Centraliza horizontalmente */
  align-items: center;
  padding: var(--sp-10);
  position: relative; /* Para posicionamento absoluto se necessário */
`;

export const GreetingContainer = styled.div`
  display: flex;
  flex-direction: column; /* Mudei para column para melhor alinhamento */
  align-items: center; /* Centraliza horizontalmente */
  text-align: center; /* Centraliza o texto */
`;

export const Greeting = styled.h2`
  margin: 0;
  color: ${(props) => props.theme.colors.selection};
  text-shadow: -0.2px -0.2px 0 #000, 0.2px -0.2px 0 #000, -0.2px 0.2px 0 #000,
    0.5px 0.5px 0 #000;
  font-size: var(--fs-2xl);
  text-align: center; /* Garante centralização do texto */
`;

export const UserName = styled.span`
  color: ${(props) => props.theme.colors.selection};
  font-weight: bold;
`;

export const Icon = styled.div`
  font-family: "Material Icons";
  text-align: center;
  font-size: var(--fs-5xl);
  color: ${(props) => props.theme.colors.selection};
  text-shadow: -0.5px -0.5px 0 #000, 0.5px -0.5px 0 #000, -0.5px 0.5px 0 #000,
    1px 1px 0 #000;
`;
export const MapSection = styled.div``;

/*
 * MapContainer / StaticMap / MapOverlay / MapMarker foram REMOVIDOS.
 *
 * Eram a moldura do `<img>` da Static Maps API do Google (com a chave literal
 * `YOUR_GOOGLE_MAPS_API_KEY` na URL, que nunca carregou) e dos pinos que ficavam
 * por cima dele, posicionados por regra de três sobre um retângulo imaginário.
 * O mapa agora é o `MapaDasLojas` (MapLibre + OpenFreeMap), que traz os próprios
 * estilos em `styles/components/MapaDasLojas.ts`.
 */

export const StoresList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StoreStatus = styled.div<{
  status: "online" | "offline" | "warning";
}>`
  width: calc(var(--u) * 10);
  height: calc(var(--u) * 10);
  border-radius: 50%;
  background-color: ${(props) =>
    props.status === "online"
      ? "#4CAF50"
      : props.status === "offline"
      ? "#F44336"
      : "#FF9800"};
  margin-right: var(--sp-10);
  flex-shrink: 0;
  margin-top: var(--sp-2);
`;

export const StoreInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--sp-8);

  /*
   * CONSULTA DE CONTAINER, e não de janela.
   *
   * Este cartão vive em larguras muito diferentes na MESMA janela: com as duas
   * barras abertas em 1440 ele tem ~360, com elas fechadas tem ~1000, e na
   * coluna dupla da Home tem a metade disso. Um @media olharia para a janela e
   * erraria nos três casos — foi por isso que, em 1440, o nome quebrava em três
   * linhas enquanto a janela "era grande".
   *
   * Declarando o container aqui, as regras abaixo passam a reagir à largura
   * REAL do cartão.
   */
  container-type: inline-size;
  container-name: cartao-da-loja;
`;

export const StoreHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--sp-8);
  margin-bottom: var(--sp-4);
  flex-wrap: wrap;
`;

/** O par etiqueta-de-estado + seta, para não brigar com o nome no wrap. */
export const StoreHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
`;

/**
 * "Carregando", "deu erro", "não há unidade". A Home precisava dos três: sem
 * eles, o que aparecia enquanto a rede não chegava era a rede FALSA que estava
 * escrita no componente.
 */
export const EstadoDaRede = styled.div<{ $erro?: boolean }>`
  padding: var(--sp-16) var(--sp-12);
  text-align: center;
  font-size: var(--fs-xs);
  line-height: 1.4;
  color: ${(props) => (props.$erro ? "#B3261E" : "#666")};
`;

export const StoreName = styled.div`
  font-weight: bold;
  color: ${(props) => props.theme.colors.text};
  font-size: var(--fs-md);
  flex: 1;
  margin-right: var(--sp-8);
  line-height: 1.2;
`;

export const StoreStatusBadge = styled.div<{
  status: "online" | "offline" | "warning";
}>`
  padding: calc(var(--u) * 3) var(--sp-6);
  background-color: ${(props) =>
    props.status === "online"
      ? "#1F7A3A"
      : props.status === "offline"
      ? "#B3261E"
      : "#FFB020"};
  /*
   * Carvão sobre o âmbar, branco sobre os outros dois.
   *
   * Branco sobre o âmbar #FF9800 dava 2,16:1 — medido no navegador. Âmbar é uma
   * cor CLARA: ela pede tinta escura, não branca. O verde e o vermelho foram
   * escurecidos até o branco passar em cima deles.
   */
  color: ${(props) => (props.status === "warning" ? "#191919" : "#ffffff")};
  border-radius: 8px;
  font-size: var(--fs-3xs);
  font-weight: bold;
  white-space: nowrap;
`;

export const StoreCompactRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--sp-12);

  /* Abaixo de 520 de CARTÃO (não de janela) as métricas e os botões não cabem
     na mesma linha: em vez de espremer os dois — que era o que fazia "Vendas"
     virar uma coluna de 60px e truncava "Detalhes" — eles empilham. */
  @container cartao-da-loja (max-width: 520px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const StoreAddress = styled.div`
  font-size: var(--fs-2xs);
  color: ${(props) => props.theme.colors.label};
  line-height: 1.2;
  flex: 1;
`;

export const StoreNavigation = styled.div`
  display: flex;
  align-items: center;
`;

export const NavButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  color: ${(props) => props.theme.colors.label};
  display: grid;
  place-items: center;
  /* Alvo de toque de verdade: o antigo tinha 4px de padding e nada mais. */
  min-width: ${ALVO_DE_TOQUE};
  min-height: ${ALVO_DE_TOQUE};

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
`;

export const StoreMetricsCompact = styled.div`
  display: grid;
  /* auto-fit + minmax faz a quebra sozinho: quatro colunas onde cabem
     quatro, duas onde cabem duas, uma no telefone — sem nenhum @media para
     manter em dia. O minimo e o que impede o numero de virar reticencias. */
  grid-template-columns: repeat(auto-fit, minmax(calc(var(--u) * 96), 1fr));
  gap: var(--sp-6);
  margin: var(--sp-4) 0;
  flex: 1;
`;

export const MetricCompact = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--sp-6) var(--sp-4);
  /* Superfície elevada do tema: o branco a 30% clareava no claro e escurecia
     no escuro, os dois na direção errada. */
  background: ${(props) => props.theme.colors.primary};
  border: 1px solid ${(props) => props.theme.colors.border}44;
  border-radius: 6px;
`;

export const MetricLabel = styled.div`
  font-size: calc(var(--u) * 9);
  color: ${(props) => props.theme.colors.label};
  margin-bottom: var(--sp-2);
  text-align: center;
`;

/*
 * O TOM DO NÚMERO vem do TEMA, não de um hex fixo.
 *
 * Eram verde #2E7D32, azul #1565C0 e âmbar #B26A00 — as versões escuras, feitas
 * para papel. Sobre o cartão do tema escuro (#252525) elas somem. As semânticas
 * do sistema de design existem em duas versões justamente por isso, e o tema já
 * carrega a certa: no escuro viram #7BD69A, #F0B65C e o azul aceso.
 */
export const MetricValue = styled.div<{
  $tom?: "verde" | "azul" | "ambar" | "neutro";
}>`
  font-size: var(--fs-xs);
  font-weight: bold;
  color: ${(props) =>
    props.$tom === "verde"
      ? props.theme.colors.bom
      : props.$tom === "azul"
      ? props.theme.colors.selection
      : props.$tom === "ambar"
      ? props.theme.colors.aviso
      : props.theme.colors.text};
  text-align: center;
  line-height: 1.2;
  /* Dinheiro em coluna estreita: quebra em vez de sumir com reticências. */
  overflow-wrap: anywhere;
`;

/*
 * Props TRANSIENTES ($). Sem o cifrão o styled-components repassa `primary` e
 * `whatsapp` para o <button> do DOM, e o React reclama no console
 * ("Received `true` for a non-boolean attribute"). O cifrão diz que a prop é só
 * para o estilo e não desce para o HTML.
 */
export const ActionButtonCompact = styled.button<{
  $primary?: boolean;
  $whatsapp?: boolean;
}>`
  ${BOTAO_LEGIVEL}
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-6);
  padding-block: var(--sp-6);
  /* O verde do WhatsApp era #128C4A: com branco por cima dava 4,31:1, medido —
     um fio abaixo do minimo. #128848 e' o mesmo verde na luminosidade que
     passa (4,52:1). O par desta linha esta' em layouts/RightBar.ts, que tem o
     mesmo botao. */
  background: ${(props) =>
    props.$primary ? "#1565C0" : props.$whatsapp ? "#128848" : "#2E7D32"};
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: var(--fs-xs);
  font-weight: 600;
  transition: opacity 0.2s;
  flex: 1 1 calc(var(--u) * 120);

  .material-icons {
    font-size: var(--fs-base);
  }

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  /* Sem telefone cadastrado o botão não pode parecer clicável: era isso que
     abria tel: vazio e wa.me/ sem numero. */
  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  /* No telefone o rótulo some e fica só o ícone: três botões com texto em
     360px de largura viram três colunas de uma letra. */
  ${ate.telefone} {
    font-size: 0;
    gap: 0;

    .material-icons {
      font-size: var(--fs-lg);
    }
  }
`;

export const StoreMetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--sp-10);
  margin-bottom: var(--sp-12);
`;

export const MetricItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--sp-8);
  background: rgba(255, 255, 255, 0.3);
  border-radius: 6px;
`;

export const StoreActions = styled.div`
  display: flex;
  gap: var(--sp-8);
  margin-bottom: var(--sp-8);
`;

export const ActionButton = styled.button<{ primary?: boolean }>`
  flex: 1;
  padding: var(--sp-10);
  background: ${(props) => (props.primary ? "#4CAF50" : "#25D366")};
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
  font-size: var(--fs-sm);

  &:hover {
    opacity: 0.9;
  }
`;

export const LastUpdate = styled.div`
  font-size: var(--fs-3xs);
  color: ${(props) => props.theme.colors.label};
  text-align: center;
`;

// Estilos mantidos para compatibilidade
export const LastOptionsContainer = styled(WelcomeContainer)``;
export const Card = styled.div`
  background-color: ${(props) => props.theme.colors.background + "cc"};
  color: ${(props) => props.theme.colors.text};
  border: 1px solid ${(props) => props.theme.colors.text};
  padding: var(--sp-20);
  border-radius: 8px;
`;

export const LastPagesContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PageItem = styled(Link)`
  padding: var(--sp-8);
  margin: var(--sp-4) 0;
  /* Superfície do tema: era branco fixo com o texto do tema por cima, e no
     escuro isso dava texto claro sobre branco. */
  background-color: ${(props) => props.theme.colors.primary};
  border: 1px solid ${(props) => props.theme.colors.border}55;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  flex-direction: row;
  display: flex;
  justify-content: center;
  text-decoration: none;
  color: ${(props) => props.theme.colors.text};

  &:hover {
    border-color: ${(props) => props.theme.colors.selection};
    color: ${(props) => props.theme.colors.selection};
  }
`;

export const PageTitle = styled.div`
  font-size: 110%;
  font-weight: bold;
`;

export const PageIcon = styled.div`
  font-family: "Material Icons";
  font-size: 150%;
  margin-right: var(--sp-10);
`;

export const EstablishmentHeader = styled.div`
  display: flex;
  align-items: center;
  padding: var(--sp-10) var(--sp-12);
  background-color: rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.08);
  }
`;

export const EstablishmentIcon = styled.span`
  font-family: "Material Icons";
  font-size: var(--fs-lg);
  color: ${(props) => props.theme.colors.label};
  margin-right: var(--sp-8);
  transition: transform 0.2s;
`;

export const EstablishmentName = styled.div`
  flex: 1;
  font-weight: bold;
  font-size: var(--fs-xs);
  color: ${(props) => props.theme.colors.text};
`;

export const EstablishmentBadge = styled.div`
  padding: var(--sp-2) var(--sp-6);
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-size: var(--fs-3xs);
  font-weight: 600;
  color: ${(props) => props.theme.colors.label};
`;

export const StoreSelectorItem = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  padding: var(--sp-10) var(--sp-12) var(--sp-10) calc(var(--u) * 30);
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background-color: ${(props) =>
    props.selected ? "rgba(254, 233, 123, 0.3)" : "transparent"};
  gap: var(--sp-10);
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(254, 233, 123, 0.2);
  }

  &:last-child {
    border-bottom: none;
  }
`;

// Adicione este novo styled component para melhorar o visual do botão azul
export const StoreActionsCompact = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-8);
  justify-content: center;
  margin-top: var(--sp-8);
`;

export const StoreItem = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: flex-start;
  padding: var(--sp-12);
  transition: all 0.2s ease;
  position: relative;
  min-height: calc(var(--u) * 100);
  /* Sem min-width:0 um filho em grid/flex se recusa a encolher abaixo do
     conteúdo — é a causa clássica de rolagem horizontal na página inteira. */
  min-width: 0;

  ${ate.telefone} {
    padding: var(--sp-8);
  }
`;

export const StoreSelectorPanel = styled.div`
  margin-top: 0;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.95);
  max-height: calc(var(--u) * 250);
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;
